function createFoldSection(nmb){
  return(`<section id="section-${nmb}" class="sec full-fold wf-section sc-bg canBeDeleted">
  <div class="mesa-fold-cont">
    <div class="grid five-col no-gap">
      <div id="w-node-bde38e41-e245-1328-b44d-a139b9b610f4-0ac9d62e" class="cont">
        <div class="img-wrap full-img-wrap"><img id="image-${nmb}" loading="lazy" src="" alt="" class="cover-img"></div>
      </div>
      <div id="w-node-bde38e41-e245-1328-b44d-a139b9b610f7-0ac9d62e" class="cont">
        <div class="pad">
          <div class="flex ver left spaced">
            <div class="cont">
              <h1 id="title-${nmb}" class="hero-par pc-text"></h1>
            </div>
            <div class="cont">
              <div class="flex ver left mini-gap">
                <div id="content-${nmb}" class="big-par pc-text"></div>
                  <a id="link-${nmb}" href="" target="_blank" class="btn prim-btn w-button pc-underline-btn d-none"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>`)
}

function createEventSection(nmb){
  return(`<section id="section-${nmb}" class="sec wf-section sc-bg canBeDeleted">
</section>`)
}

function createSmallBannerSection(nmb){
  return(`<section id="section-${nmb}" class="sec alt-txt-color wf-section sc-bg canBeDeleted">
    <div class="pad">
      <div class="cont">
        <div class="cont abs-cont">
          <div class="img-wrap full-img-wrap"><img id="image-${nmb}" loading="lazy" src="" alt="" class="cover-img"></div>
        </div>
        <div class="cont">
          <div class="pad">
            <div class="grid two-col">
              <div id="w-node-_935547ba-8888-f394-0af8-f4c648239d73-0ac9d62e" class="cont">
                <div class="flex ver left bot">
                  <h2 id="title-${nmb}" class="alt-txt-color pc-text"></h2>
                </div>
              </div>
              <div id="w-node-_992d1858-8fbe-20e2-2e15-170af0f5f2ee-0ac9d62e" class="cont">
                <div class="flex ver big-gap">
                  <div class="cont"></div>
                  <div class="cont">
                    <div class="flex ver right small-gap">
                      <div id="content-${nmb}" class="pc-text"></div>
                        <a id="link-${nmb}" href="" target="_blank" class="btn sec-btn w-button pc-underline-btn d-none"></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>`)
}

function createBigBannerSection(nmb){
  return(`<section id="section-${nmb}" class="sec dark-sec wf-section canBeDeleted">
    <div class="mesa-fold-cont">
      <div class="cont abs-cont">
        <div class="cont abs-cont">
          <div class="img-wrap full-img-wrap"><img id="image-${nmb}" loading="lazy" src="" alt="" class="cover-img"></div>
        </div>
      </div>
      <div class="cont abs-cont">
        <div class="pad">
          <div class="grid two-col top">
            <div id="w-node-_4fadd7d0-0068-8321-3ad5-be7f4d3a4df1-0ac9d62e" class="cont">
              <div class="flex ver mid">
                <h2 id="title-${nmb}" class="hero-par white-txt tc-text"></h2>
              </div>
            </div>
            <div id="w-node-_0698ccc8-a5d5-0355-69c5-872ce23c8279-0ac9d62e" class="cont">
              <div class="flex ver right mid gap">
                <div id="content-${nmb}" class="tc-text"></div>
                  <a id="link-${nmb}" href="" target="_blank" class="btn sec-btn w-button tc-underline-btn d-none"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>`)
}

function createImageLeftBannerSection(nmb){
  return(`<section id="section-${nmb}" class="sec wf-section sc-bg canBeDeleted">
    <div class="grid five-col no-gap">
      <div id="w-node-_636d8845-a755-e905-9ac5-04d2d4623314-0ac9d62e" class="cont">
        <div class="img-wrap wide-img-wrap"><img id="image-${nmb}" loading="lazy" src="" alt="" class="cover-img"></div>
      </div>
      <div id="w-node-_586a6342-2f28-f8db-1c4e-a3e63d15a14f-0ac9d62e" class="cont">
        <div class="pad no-right-pad">
          <div class="flex ver spaced small-gap">
            <div class="cont med-cont">
              <h2 id="title-${nmb}" class="h1 pc-text"></h2>
            </div>
            <div class="cont med-cont">
              <div class="flex ver left gap">
                <div id="content-${nmb}" class="pc-text"></div>
                    <a id="link-${nmb}" href="" target="_blank" class="btn prim-btn w-button pc-underline-btn d-none"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>`)
}

function createImageRightBannerSection(nmb){
  return(`<section id="section-${nmb}" class="sec wf-section sc-bg canBeDeleted">
    <div class="grid five-col no-gap">
      <div id="w-node-_9e9b8d08-e358-cd5c-1ced-6d5a9c18b87a-0ac9d62e" class="cont">
        <div class="pad no-right-pad">
          <div class="flex ver spaced small-gap">
            <div class="cont med-cont">
              <h2 id="title-${nmb}" class="h1 pc-text"></h2>
            </div>
            <div class="cont med-cont">
              <div class="flex ver left gap">
                <div id="content-${nmb}" class="pc-text"></div>
                    <a id="link-${nmb}" href="" target="_blank" class="btn prim-btn w-button pc-underline-btn d-none"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="w-node-_9e9b8d08-e358-cd5c-1ced-6d5a9c18b877-0ac9d62e" class="cont">
        <div class="img-wrap wide-img-wrap"><img id="image-${nmb}" loading="lazy" src="" alt="" class="cover-img"></div>
      </div>
    </div>
  </section>`)
}

function createOverBannerSection(nmb){
  return(`<section id="section-${nmb}" class="sec dark-sec wf-section tc-bg canBeDeleted">
    <div class="flex ver">
      <div class="cont">
        <div class="pad">
          <div class="flex ver cen">
            <div class="cont narrow-cont">
              <div class="flex ver cen gap">
                <h2 id="title-${nmb}" class="h1 pc-text"></h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cont">
        <div class="img-wrap banner-img-wrap"><img id="image-${nmb}" loading="lazy" src="" alt="" class="cover-img"></div>
      </div>
      <div class="cont">
        <div class="pad">
          <div class="flex ver cen">
            <div class="cont narrow-cont">
              <div class="flex ver cen gap">
                <div id="content-${nmb}" class="normal-par pc-text"></div>
                  <a id="link-${nmb}" href="" target="_blank" class="btn prim-btn w-button pc-underline-btn d-none"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>`)
}

function createBigVideoSection(nmb){
  return(`<section id="section-${nmb}" class="sec wf-section canBeDeleted">
    <div class="video-wrap w-video w-embed" style="width:100vw;height:100vh">
      <iframe id="video-${nmb}" width="966" height="543" src="" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
    </div>
  </section>`)
}

function createSmallVideoSection(nmb){
  return(`<section id="section-${nmb}" class="sec wf-section sc-bg canBeDeleted">
    <div class="pad no-side-pad">
      <div class="grid five-col no-gap">
        <div id="w-node-_0f65fa2e-1021-766b-d213-14fba4493d1e-0ac9d62e" class="cont">
          <div class="video-wrap w-video w-embed small">
            <iframe id="video-${nmb}" width="966" height="543" src="" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
          </div>
        </div>
        <div id="w-node-_0f65fa2e-1021-766b-d213-14fba4493d21-0ac9d62e" class="cont">
          <div class="pad no-right-pad">
            <div class="flex ver spaced">
              <div class="cont med-cont">
                <h2 id="title-${nmb}" class="h1 pc-text"></h2>
              </div>
              <div class="cont med-cont">
                <div class="flex ver left gap">
                  <div id="content-${nmb}" class="pc-text"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>`)
}

function createGridGallerySection(nmb){
  return(`<section id="section-${nmb}" class="sec wf-section sc-bg canBeDeleted">
    <div class="pad">
      <div class="flex ver gap">
        <div class="cont">
          <div class="flex ver cen">
            <div class="cont narrow-cont">
              <div class="flex ver cen mid small-gap">
                <h2 id="title-${nmb}" class="pc-text"></h2>
                <div id="content-${nmb}" class="pc-text"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="cont">
          <div id="img-container-${nmb}" class="grid two-col">
          </div>
        </div>
      </div>
    </div>
  </section>`)
}

function createSliderGallerySection(nmb){
  return(`<section id="section-${nmb}" class="sec dark-sec wf-section tc-bg canBeDeleted">
    <div class="flex ver">
      <div class="cont">
        <div class="pad">
          <div class="flex ver cen">
            <div class="cont narrow-cont">
              <div class="flex ver cen small-gap">
                <h2 id="title-${nmb}" class="pc-text"></h2>
                <div id="content-${nmb}" class="normal-par pc-text"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cont">
        <div data-delay="4000" data-animation="slide" class="mesa-slider w-slider" data-autoplay="false" data-easing="ease" data-hide-arrows="false" data-disable-swipe="false" data-autoplay-limit="0" data-nav-spacing="3" data-duration="500" data-infinite="true">
          <div id="img-container-${nmb}" class="mesa-slider-mask w-slider-mask">
          </div>
          <div class="arrow-wrap w-slider-arrow-left">
            <div class="mesa-slider-icon w-icon-slider-left pc-text"></div>
          </div>
          <div class="arrow-wrap w-slider-arrow-right">
            <div class="mesa-slider-icon w-icon-slider-right pc-text"></div>
          </div>
          <div class="hidden w-slider-nav w-round"></div>
        </div>
      </div>
    </div>
  </section>`)
}

function createListGallerySection(nmb){
  return(`<section id="section-${nmb}" class="sec wf-section sc-bg canBeDeleted">
    <div class="pad">
      <div class="flex ver gap">
        <div class="cont">
          <div class="flex ver cen">
            <div class="cont narrow-cont">
              <div class="flex ver cen mid small-gap">
                <h2 id="title-${nmb}" class="pc-text"></h2>
                <div id="content-${nmb}" class="pc-text"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cont">
      <div id="img-container-${nmb}" class="flex ver gap">
      </div>
    </div>
  </section>`)
}

function createMapSection(nmb){
  return(`<section id="section-${nmb}" class="sec wf-section sc-bg canBeDeleted">
  <div class="flex ver">
    <div class="cont">
      <div class="pad">
        <div class="flex ver left">
          <h2 id="title-${nmb}" class="pc-text"></h2>
        </div>
      </div>
    </div>
    <div class="cont">
      <div class="grid three-col no-gap">
        <div id="w-node-_42baf421-b006-b7da-ec18-7c0cc9a77bc1-0ac9d62e" class="cont">
          <div class="img-wrap wide-img-wrap w-widget w-widget-map" id="ubications-${nmb}" data-widget-style="roadmap" data-widget-latlng="" aria-label="" data-enable-scroll="true" role="region" title="" data-enable-touch="true" data-widget-zoom="12" data-widget-tooltip=""></div>
        </div>
        <div id="w-node-_714b1344-65b6-cb42-75c7-572ea806871c-0ac9d62e" class="cont">
          <div class="pad small-pad">
            <div class="flex ver gap">
              <div class="cont"></div>
              <div class="cont">
                <div id="ubication-element-container-${nmb}" class="flex ver small-gap">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>`)
}

function createTextSection(nmb){
  return(`<section id="section-${nmb}" class="sec wf-section sc-bg canBeDeleted">
  <div class="pad big-pad">
    <div class="flex ver gap">
      <div class="cont">
        <div class="flex ver cen">
          <div class="cont med-cont">
            <div class="flex ver cen mid gap">
              <h2 id="title-${nmb}" class="pc-text"></h2>
              <div id="content-${nmb}" class="big-par pc-text"></div>
                <a id="link-${nmb}" href="" target="_blank" class="btn prim-btn w-button pc-underline-btn d-none"></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>`)
}

function createEventItem(nmb,vestimenta="",fecha="",nombre="",descripcion="",link="",ubicacion=""){
  var date = fecha.split(fecha.indexOf('T'))
  return(`<div class="pad canBeDeleted ws-Event-${nmb}-0">
      <div class="grid three-col with-separator no-gap">
        <div class="cont">
          <div class="pad">
            <div class="flex ver right gap">
              <h2 id="ws-title-val-${nmb}" class="pc-text">${nombre}</h2>
              <div id="ws-description-val-${nmb}" class="pc-text">${descripcion}</div>
            </div>
          </div>
        </div>
        <div id="w-node-_68d10172-e376-95d2-decd-27f62f0a6b9e-0ac9d62e" class="separator pc-bg"></div>
        <div class="cont">
          <div class="pad">
            <div class="flex ver left gap">
              <h2 class="pc-text"><span class="classdate" id="ws-date1-val-${nmb}">${fecha.replace('T', ' ').split(' ')[0].replaceAll('-', ' ')}</span></h2>
              <div class="cont">
                <div class="flex ver left mini-gap">
                  <div class="pc-text"><span class="classdate" id="ws-date2-val-${nmb}">${fecha.replace('T', ' ').split(' ')[1].replace(':00+00:00', ' ')}</span></div>
                  <div class="pc-text"><span id="ws-place-valText-${nmb}">${ubicacion}</span></div>
                  <div id="ws-outfit-val-${nmb}" class="pc-text">${vestimenta}</div>
                  <div class="d-none" id="ws-place-val-${nmb}"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>`)
}

function createUbicationItem(nmb,link,ubicacion){
  return(`<div id="section-${nmb}" class="cont canBeDeleted">
                      <div class="flex ver left mini-gap">
                        <h3 id="title-${nmb}" class="card-title pc-text">${ubicacion}</h3>
                        <div id="content-${nmb}" class="pc-text"></div>
                        <a href="${link}" id="link-${nmb}" target="_blank" class="btn prim-btn w-button pc-underline-btn">Ver en Google Maps</a>
                      </div>
                    </div>`)
}

function createGridItem(nmb){
  return(`<div id="section-${nmb}" class="gall-card canBeDeleted">
                <div class="flex ver small-gap">
                  <div class="cont">
                    <div class="img-wrap fhd-img-wrap"><img id="image-${nmb}" loading="lazy" src="" alt="" class="cover-img"></div>
                  </div>
                  <div class="cont">
                    <div class="flex ver left small-gap">
                      <div id="title-${nmb}" class="gall-card-caption pc-text"></div>
                      <div id="content-${nmb}" class="small-par pc-text"></div>
                        <a id="link-${nmb}" href="" target="_blank" class="btn alt-btn w-button pc-text d-none"></a>
                    </div>
                  </div>
                </div>
              </div>`)
}

function createSliderItem(nmb){
  return(`<div id="section-${nmb}" class="mesa-slide w-slide canBeDeleted">
              <div class="img-wrap banner-img-wrap"><img id="image-${nmb}" loading="lazy" src="" alt="" class="cover-img"></div>
            </div>`)
}

function createListItem(nmb){
  return(`<div id="section-${nmb}" class="gall-card canBeDeleted">
            <div id="w-node-_8b5097d0-1981-486c-61b4-fe02ab552443-0ac9d62e" class="grid three-col mid no-gap">
              <div id="w-node-_349ab496-8036-eca4-e2c5-ca76a2ee2720-0ac9d62e" class="cont">
                <div class="pad">
                  <div class="flex ver left spaced small-gap">
                    <div class="cont">
                      <h3 id="title-${nmb}" class="hor-card-title pc-text"></h3>
                    </div>
                    <div class="cont">
                      <div class="flex ver left small-gap">
                        <div id="content-${nmb}" class="normal-par pc-text"></div>
                          <a id="link-${nmb}" href="" target="_blank" class="btn prim-btn w-button pc-underline-btn d-none"></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="w-node-_7ae307c7-6bbd-7001-b37f-d1fdd2f96af3-0ac9d62e" class="cont">
                <div class="cont">
                  <div class="img-wrap fhd-img-wrap"><img id="image-${nmb}" loading="lazy" src="" alt="" class="cover-img"></div>
                </div>
              </div>
            </div>
          </div>`)
}